import { PropType } from 'vue';
import { BreadcrumbLink } from '../breadcrumb.shared';

export const props = {
  link: {
    type: Object as PropType<BreadcrumbLink>,
    default: () => ({}),
  },
};
